
const concatRow = (row) => {
  const strRow = [];
  Object.values(row).forEach((element) => {
    strRow.push(element);
  });
  return strRow.toString();
};

// eslint-disable-next-line max-len
const filterNumber = (data, sort) => data.sort((firstVal, secondVal) => firstVal[sort.value] - secondVal[sort.value]);

const filterString = (data, sort) => data.sort((firstValue, secondValue) => {
  const first = firstValue[sort.value];
  const second = secondValue[sort.value];
  if (first > second) return 1;
  if (second > first) return -1;
  return 0;
});

const filterDate = (data, sort) => data.sort((firstDate, secondDate) => {
  const first = new Date(firstDate[sort.value]);
  const second = new Date(secondDate[sort.value]);
  return first.getTime() - second.getTime();
});

const sortSearch = (data, query) => data.sort((firstVal, secondVal) => {
  const first = concatRow(firstVal).indexOf(query);
  const second = concatRow(secondVal).indexOf(query);
  return first - second;
});
export {
  filterNumber, filterDate, filterString, sortSearch,
};
